import { useEffect, useState } from 'react';
import { Box, Button, TextField, Typography, CircularProgress, Alert } from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { resetPassword, clearErrors } from '../../actions/userAction';
import MetaData from '../Layouts/MetaData';
import AuthLayout from './AuthLayout'; // Assuming AuthLayout handles consistent styling

const ResetPassword = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const params = useParams();
    const { error, success, loading } = useSelector((state) => state.forgotPassword);

    const [password, setPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();

        if (password.length < 8) {
            return;
        }
        if (password !== confirmPassword) {
            return;
        }

        const formData = new FormData();
        formData.set("password", password);
        formData.set("confirmPassword", confirmPassword);
        dispatch(resetPassword(params.token, formData));
    };

    useEffect(() => {
        if (error) {
            console.error(error);
            dispatch(clearErrors());
        }
        if (success) {
            navigate("/login");
        }
    }, [dispatch, error, success, navigate]);

    return (
        <AuthLayout
            sidebarTitle="Reset Password"
            sidebarTagline="Get access to your Orders, Wishlist and Recommendations"
        >
            <MetaData title="Reset Password - AmritLok" />
            <Typography component="h2" variant="h5" sx={{ mb: 3, fontWeight: 600, textAlign: 'center' }}>
                Reset Password
            </Typography>
            <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>
                {error && <Alert severity="error" sx={{ width: '100%', mb: 2 }}>{error}</Alert>}
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="password"
                    label="New Password"
                    type="password"
                    id="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    inputProps={{ minLength: 8 }}
                    helperText={password.length < 8 ? "Password must be at least 8 characters" : ""}
                    error={password.length < 8}
                />
                <TextField
                    margin="normal"
                    required
                    fullWidth
                    name="confirmPassword"
                    label="Confirm New Password"
                    type="password"
                    id="confirmPassword"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    error={confirmPassword !== password}
                    helperText={confirmPassword !== password ? "Passwords do not match" : ""}
                />
                <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    sx={{ mt: 3, mb: 2, py: 1.5 }}
                    disabled={loading || password.length < 8 || confirmPassword !== password}
                >
                    {loading ? <CircularProgress size={24} /> : 'Submit'}
                </Button>
            </Box>
        </AuthLayout>
    );
};

export default ResetPassword;